import { render, staticRenderFns } from "./ResearchInSectionSearch.vue?vue&type=template&id=4bc6f7f5"
import script from "./ResearchInSectionSearch.vue?vue&type=script&lang=js"
export * from "./ResearchInSectionSearch.vue?vue&type=script&lang=js"
import style0 from "./ResearchInSectionSearch.vue?vue&type=style&index=0&id=4bc6f7f5&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc6f7f5')) {
      api.createRecord('4bc6f7f5', component.options)
    } else {
      api.reload('4bc6f7f5', component.options)
    }
    module.hot.accept("./ResearchInSectionSearch.vue?vue&type=template&id=4bc6f7f5", function () {
      api.rerender('4bc6f7f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchInSectionSearch.vue"
export default component.exports